export enum GaugeColorMode {
	SEGMENTED = 'segmented',
	DYNAMIC = 'dynamic'
}
